/** @format */

import React from "react";
import "./chartStyle.css";
import {
  AreaChart,
  Area,
  ResponsiveContainer,
  XAxis,
  Tooltip,
  BarChart,
  Bar,
  YAxis,
  Text,
  Label,
} from "recharts";
import { useMediaQuery } from "@chakra-ui/react";
import colors from "../../../utils/colors";

export interface IChartToolTip {
  payload?: any;
  label?: any;
  active?: boolean;
  hasUsd?: boolean;
}

const ChartToolTip: React.FC<IChartToolTip> = ({
  payload,
  label,
  active,
  hasUsd,
}: IChartToolTip) => {
  if (active && payload?.length) {
    const year = payload[0]?.payload?.year ?? ""
    return (
      <div className="chart-tooltip">
        <p className="chart-tooltip-date">{`${
          (payload &&
            (payload[0]?.payload?.name + " " + year)) ||
          label
        }`}</p>
        <div className="chart-tooltip-balance">
          <p>{payload && payload[0]?.dataKey} : </p>
          <p className="chart-bold">{payload[0]?.value}</p>
        </div>
      </div>
    );
  }

  return null;
};

const data = [
  {
    key: 0,
    name: "A",
  },
  {
    key: 0,
    name: "B",
  },
  {
    key: 0,
    name: "C",
  },
];

function AppointmentsBarChart({
  graphData,
  dataKey,
  hasUsd,
  xAxis,
  yAxis,
  margin,
}: {
  graphData?: any;
  hasUsd?: boolean;
  dataKey?: any;
  xAxis?: boolean;
  yAxis?: boolean;
  margin?: { top?: number; left?: number; right?: number; bottom?: number };
}) {
  const [isLessThan768] = useMediaQuery("(max-width: 767.98px)");

  return (
    <ResponsiveContainer
      width="100%"
      minWidth="100%"
      height={400}
      minHeight={100}
    >
      <BarChart
        data={graphData?.length ? graphData : data}
        margin={{
          top: margin?.top ?? 20,
          right: margin?.right ?? 0,
          left: margin?.left ?? 0,
          bottom: margin?.bottom ?? 0,
        }}
      >
        {xAxis && (
          <XAxis
            dataKey="name"
            stroke={colors.placeholderColor}
            tickLine={false}
            // tickCount={5}
            axisLine={false}
            fontSize={12}
          />
        )}
        {yAxis && (
          <YAxis
            dataKey={dataKey}
            stroke={colors.placeholderColor}
            tickLine={false}
            tickCount={5}
            axisLine={false}
            fontSize={12}
            dx={-20}
          ></YAxis>
        )}
        <Tooltip
          content={<ChartToolTip hasUsd={hasUsd} />}
          cursor={{ fill: colors.white }}
        />
        <Bar
          type="monotone"
          dataKey={dataKey}
          stroke={colors.primary}
          fill={colors.primary}
          barSize={40}
          radius={[8, 8, 0, 0]}
        />
        <Tooltip />
      </BarChart>
    </ResponsiveContainer>
  );
}

export default AppointmentsBarChart;
